import { PaymentStatusCode } from '../../../types';

export class PollStatusResponse {
    status: PaymentStatusCode;

    description: string;
}
